import {UserLoginPrincipal} from "../http/protocol";
import {t} from "../i18n";
import * as React from "react";

export function PrincipalSelector(props: { principals: UserLoginPrincipal[], principal: UserLoginPrincipal, hideDescription?: boolean, setPrincipal: (p: UserLoginPrincipal) => void }) {
    const {setPrincipal, principal, principals} = props;
    return (
        <>
            <div className="tabbar-container">
                <ul className="nav nav-tabs cashier-popup row">
                    {principals.map(p => {
                        return (
                            <li key={p} onClick={() => setPrincipal(p)}
                                className={"nav-item " + (principal == p ? "active" : "")}>
                                <span className={"nav-link"}>{t("principal." + p)}</span>
                            </li>
                        )
                    })}
                </ul>

            </div>
            {!props.hideDescription && <span className={"principal-description"}>{t("principal.description")}</span>}
        </>
    )
}